import dayjs from "dayjs";

const dateFormat = (date: Date | string, template?: string | undefined) => {
  const isValid = dayjs(date).isValid();
  if (!isValid) {
    return "";
  } else {
    return dayjs(date).format(template);
  }
};

export default dateFormat;
